
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
const testingItem = namespace("testing-item");
const base = namespace("base");
@InjectFunction("emptyToLine", "appCode", "permitApp")
@Component({
  components: { SwitchStatus, StandardFlag }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("test.select-test-template"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table",
  checkableFuncName: "checkable"
})
export default class TestingItemList extends Vue {
  @testingItem.Action getTestingTemplateList;
  @testingItem.Action updateItemTemplateStatus;
  @testingItem.Action syncTestTemplate;
  @base.Action getDictionaryList;

  searchForm = {
    checkTemplateName: "",
    checkTemplateNo: "",
    source: ""
  };
  testTemplateList: any[] = [];
  get searchList() {
    return [
      {
        label: t("setting.test-template-name"),
        type: "input",
        value: "",
        prop: "checkTemplateName"
      },
      {
        label: t("setting.test-template-number"),
        type: "input",
        value: "",
        prop: "checkTemplateNo"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "base.from-source",
              type: "select",
              value: "",
              selectList: this.testTemplateSourceList,
              prop: "source"
            }
          ]
        : [])
    ];
  }
  testTemplateSourceList: any = [];
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    return this.updateItemTemplateStatus({
      status: status,
      checkTemplateCodeArray: selectedRow
        ? [selectedRow.checkTemplateCode]
        : this.mix_selectedRows.map(item => item.checkTemplateCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getTestingTemplateList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      status: "9"
    }).then(data => {
      this.testTemplateList = data.data.list;
      return data;
    });
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("check_source").then(data => {
      this.testTemplateSourceList = data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/test-template-edit/${row.checkTemplateCode}`);
  }
  handleView(row) {
    this.$router.push(`/setting/test-template-view/${row.checkTemplateCode}`);
  }
  checkable(row) {
    if (this.permitApp("speedbiz-operation")) {
      return true;
    }
    return row.source === "2";
  }
  handleSync(row) {
    this.syncTestTemplate({
      checkTemplateCode: row.checkTemplateCode
    }).then(() => {
      this.$message.success(t("v213.detection-template-has-been-synchronized-to-the-store"));
      this.loadListData();
    });
  }
}
